module.exports = __webpack_public_path__ + "resources/bootstrap/fonts/glyphicons-halflings-regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/bootstrap/fonts/glyphicons-halflings-regular.ttf
// module id = 336
// module chunks = 0